import * as React from 'react';
import { Form, Input, EditModes } from 'library';
import { IFormData, IFormState, SystemFormDetail } from 'library/form/SystemFormDetail';

interface IDataModel extends IFormData {
    PrimaryKeyEncrypted?: string,
    Year?: string,
    ContractAmount?: string,
    ProfitAmount?: string,
    FTECount?: string,
    TBContractAmount?: string,
    TBProfitAmount?: string,
    TBFTECount?: string,
    OpportunityId?: string,
    RowVersion?: string
}


///**
//* @author:Sanju Bishnoi
//* @description: format currency for the amount.
//*/
//const formatter = new Intl.NumberFormat('en-US', {
//    style: 'currency',
//    currency: 'USD',
//    minimumFractionDigits: 2,
//});

export default class AddAnnuelContracts extends SystemFormDetail<IDataModel> {
    constructor(props: any) {
        super(props);
    }

    initial = (): IFormState<IDataModel> => {
        return {
            formData: {
                PrimaryKeyEncrypted: (this.props.data && this.props.data.PrimaryKeyEncrypted) ? this.props.data.PrimaryKeyEncrypted : undefined,
                OpportunityId: (this.props.data && this.props) ? this.props.data : undefined
            },
        }
    }

    load = (data: IDataModel) => {
        if (data) {
            this.setState({
                formData: {
                    ...data,
                    PrimaryKeyEncrypted: data.PrimaryKeyEncrypted,
                    Year: data.Year,
                    ContractAmount:data.ContractAmount,
                    ProfitAmount: data.ProfitAmount,
                    FTECount: data.FTECount,
                    TBContractAmount: data.TBContractAmount,
                    TBProfitAmount: data.TBProfitAmount,
                    TBFTECount: data.TBFTECount,
                    OpportunityId: data.OpportunityId,
                    RowVersion: data.RowVersion,
                }
            })
        }
    }

    render() {
        return (<>
            <Form
                label="Annual Contract"
                url={'AnnuelContract'}
                onLoad={this.load}
                showReview={false}
                primaryKeyEncrypted={this.state.formData.PrimaryKeyEncrypted}
                securityObject="Top.AnnualContract"
                schema="Top" table="AnnualContract"
                onInitialize={this.initialize}
                onClear={this.initialize}
                onValidate={this.validate}
                onPrepare={this.prepare}
                onRecordUpdated={this.onRecordUpdated}>

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        isRequired={true}
                        id="Year"
                        name="Year"
                        label='Year'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        validator={this.validator}
                        value={this.state.formData.Year} />
                </div>

                <div className="col-md-4 col-12 mb-2 currency-input">
                    <Input
                        isRequired={true}
                        id="ContractAmount"
                        name="ContractAmount"
                        label='Annual Contract Amount'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        validator={this.validator}
                        value={this.state.formData.ContractAmount} />
                    <span className="currency-icon">$</span>
                </div>

                <div className="col-md-4 col-12 mb-2 currency-input">
                    <Input
                        isRequired={true}
                        id="ProfitAmount"
                        name="ProfitAmount"
                        label='Annual Profit Amount'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        validator={this.validator}
                        value={this.state.formData.ProfitAmount} />
                    <span className="currency-icon">$</span>
                </div>

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        isRequired={true}
                        id="FTECount"
                        name="FTECount"
                        label='FTE Count'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        validator={this.validator}
                        value={this.state.formData.FTECount} />
                </div>

                <div className="col-md-4 col-12 mb-2 currency-input">
                    <Input
                        isRequired={true}
                        id="TBContractAmount"
                        name="TBContractAmount"
                        label='TB Contract Amount'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        validator={this.validator}
                        value={this.state.formData.TBContractAmount} />
                    <span className="currency-icon">$</span>
                </div>

                <div className="col-md-4 col-12 mb-2 currency-input">
                    <Input
                        isRequired={true}
                        id="TBProfitAmount"
                        name="TBProfitAmount"
                        label='TB Profit Amount'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        validator={this.validator}
                        value={this.state.formData.TBProfitAmount} />
                    <span className="currency-icon">$</span>
                </div>

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        isRequired={true}
                        id="TBFTECount"
                        name="TBFTECount"
                        label='TB FTE Count'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        validator={this.validator}
                        value={this.state.formData.TBFTECount} />
                </div>
            </Form>

        </>)
    }
};